<template>
  <div class="language">
    <dp-select v-model="lang" class="lang" size="large">
      <dp-select-option v-for="item in locales" :key="item" :value="item"
        >{{ item.toUpperCase() }}
      </dp-select-option>
    </dp-select>
  </div>
</template>

<script>
export default {
  data() {
    return {
      locales: ["de", "en"],
      lang: "de",
    };
  },
  watch: {
    lang() {
      this.$i18n.locale = this.lang;
      this.$store.commit("addLangMutation", this.lang);
    },
  },
  created() {
    this.$i18n.locale = "de";
  },
};
</script>

<style>
</style>